{
	"outbox": "Outbox",
	"productAllocation": "Product allocation",
	"languageManagement": "Language management"
}
